import moment from 'moment';
import { viewItemDataLayer, selectItemDataLayer, addToCartDataLayer, generateLeadDataLayer } from '../autoload/gtm';


$.fn.extend({
  toggleHtml: function (a, b) {
    return this.html(this.html() == b ? a : b);
  },
});

$(document).on('click', ".read-more", function () {
  $(".tour-main-block__story").toggleClass("more-text");
  $(".tour-main-block__story-block").toggleClass("hide");
  $(this).find('span').toggleHtml(translations.viewMore, translations.hide);
  $(this).find('span').toggleClass("less-info");
});

$(document).on('click', ".more-lang", function () {
  $(".languages-list>span:nth-child(n+4)").toggle();
  $(".more-lang").toggleHtml(translations.viewMoreLang, translations.hide);
  $(".more-lang").toggleClass("less-info-op");
});
$(document).on('click', ".more-info", function () {
  $(".info-list>span:nth-child(n+4)").toggle();
  $(".more-info").toggleHtml(translations.viewMoreInfo, translations.hide);
  $(".more-info").toggleClass("less-info-op");
});
$(document).on('click', ".more-public-prices", function () {
  $(".info-block__public-price:not(:first)").toggle();
  $(".more-public-prices").toggleHtml(translations.viewMorePrices, translations.hide);
  $(".more-public-prices").toggleClass("less-info-op");
});
$(document).on('click', ".more-private-prices", function () {
  $(".info-block__private-price:not(:first)").toggle();
  $(".more-private-prices").toggleHtml(translations.viewMorePrices, translations.hide);
  $(".more-private-prices").toggleClass("less-info-op");
});
$(document).on('click', ".calendar__date", function () {
  $(".calendar,.calendar__explanation-wrapper").toggleClass("hide-calendar");
  $(".calendar__date").toggleClass("opened");
  $(".calendar > .ui-datepicker-inline").toggle();
});
$(document).on('click', ".current", function () {
  $(this).toggleClass("opened");
});
let datesArr;
let calendar = $(".calendar");
let preloader = $(".calendar__preloader");
let selectedTourDate = calendar.attr('data-selecteddate');
let currentDay;

let cartIcon = $(".header-icons__item_cart").children("div");

let successMessage = $(".filters-tour__success");

let languageSelectValue = $(
  ".filters-tour__lang select option:selected"
).text();
let language = $('.filters-tour__lang select').val();

let tourId = $('.filters-tour__variants select').val();
let publicOrPrivate = $(".filters-tour__radio:checked").attr('data-value');

let departure = $(".filters-tour__departureSelect");
let departureSelect = $(".filters-tour__departureSelect select");
let departureSelectValue;
let departureTitle = departureSelect.attr("data-title");

let options = $(".filters-tour__options");
let optionsSelect = $(".filters-tour__options select");
let optionsSelectValue;
let optionsSelectId;

let publicParticipants = $('.filters-tour__public-participants');

let optionsTitle = optionsSelect.attr("data-title");

let participants = $(".filters-tour__participants");
let participantsSelect = $(".filters-tour__participants select");
let participantsTitle = participantsSelect.attr("data-title");

let bookButton = $(".filters-tour__btn input");
let postId = $(".filters-tour__btn").attr("data-post-id");

let currentCode;

$(".sel > select").niceSelect();

if (themeVars['single'] == true && themeVars['single-type'] == 'tour') {

  let itemLayer = [
    {
      "item_id": $(".calendar").attr("data-productcode"),
      "item_name": $(".entry-title").text(),
    },
  ];
  
  viewItemDataLayer($(".filters-tour_form-block").attr("data-advertisingPrice"), itemLayer);

  initCalendar();
  calendar.datepicker("setDate", selectedTourDate);

  publicOrPrivateChecker();
  getPriceOptions(selectedTourDate);

}

$(document).on("change", ".filters-tour__lang select", function () {
  languageSelectValue = $(".filters-tour__lang select option:selected").text();
  language = $('.filters-tour__lang select').val()
  createGetQuery();
});

function publicOrPrivateChecker() {
  departure.removeClass("show");
  options.removeClass("show");
  publicParticipants.removeClass("show");
  participants.removeClass("show");

  publicOrPrivate = $(".filters-tour__radio:checked").attr('data-value');
  let code = $(".filters-tour__radio:checked").val();

  let price = $(".filters-tour__radio:checked").attr("data-price");
  calendar.attr("data-productcode", code);
  $("#priceValue").attr("data-advPrice", price);
  $("#priceValue").html(price);


  if (typeof code !== 'undefined') {
    updateCalendar(code);
  }

  initCurrentDate();
  advertisingPrice();

  if (publicOrPrivate == 'public'
  ) {
    $('.day-of-tour__info-text_private').hide();
    $('.day-of-tour__info-text_public').show();
    $('.private').hide();
  } else {
    $('.private').show();
    $('.day-of-tour__info-text_private').show();
    $('.day-of-tour__info-text_public').hide();
  }
}

$(document).on('change', ".filters-tour__radio", function () {

  $('.preloader').hide();
  publicOrPrivateChecker();
  createGetQuery();

  let tourId = $('.filters-tour__btn').attr('data-post-id');
  let type = $(".filters-tour__radio:checked").attr('data-value');
  updateStoryAndLanguages(tourId, type);
});

$(document).on("change", ".filters-tour__options", function () {
  advertisingPrice();
  optionsSelectValue = $(
    ".filters-tour__options select option:selected"
  ).text();

  optionsSelectId = $(".filters-tour__options select option:selected").attr(
    "data-id"
  );


  let min = $("option:selected", this).attr("data-min");
  let max = $("option:selected", this).attr("data-max");

  if ((typeof min !== "undefined") & (typeof max !== "undefined")) {
    participants.removeClass("show");

    participantsSelect.html("");

    if (max > min) {
      participantsSelect.append(
        "<option disabled selected>" + participantsTitle + "</option>"
      );
      participants.addClass("show");
    }

    for (let i = min; i <= max; i++) {
      participantsSelect.append("<option>" + i + "</option>");
    }

    participantsSelect.niceSelect();
    participantsSelect.niceSelect("update");

    if (max == min) {
      calculatePrice();
    }
  }
});
$(document).on("change", ".adult select", function () {
  calculatePrice();
});
$(document).on("change", ".child select", function () {
  calculatePrice();
});
$(document).on("change", ".infant select", function () {
  calculatePrice();
});
$(document).on("change", ".filters-tour__participants", function () {
  calculatePrice();
});

$(document).on("change", ".filters-tour__departureSelect select", function () {

  advertisingPrice();
  departureSelectValue = $(
    ".filters-tour__departureSelect select option:selected"
  ).text();
  let priceOptions;
  let startTimeLocal = $("option:selected", this).val();

  options.removeClass("show");
  participants.removeClass("show");
  publicParticipants.removeClass("show");

  let sessionsJson = localStorage.prices;
  let sessions = JSON.parse(sessionsJson);

  sessions.forEach(session => {
    if (session.startTimeLocal == startTimeLocal) {
      priceOptions = session.priceOptions;
    }
  });


  if (publicOrPrivate == 'public') {
    publicParticipants.addClass("show");
    publicParticipants.html("");
    priceOptions.forEach(option => {
      let id = option.id;
      let min = 1;
      let max = 50;
      let optionString = '<span data-price="' + option.price + '"';
      let optionLabel = option.label == 'Adult' ? translations.adult : option.label == 'Child' ? translations.child : translations.infant;


      optionString = optionString + 'data-id="' + id + '" ';

      if (typeof option.minQuantity !== "undefined") {
        min = option.minQuantity;
      }
      optionString = optionString + 'data-min="' + min + '" ';

      if (typeof option.maxQuantity !== "undefined") {
        max = option.maxQuantity;
      }
      optionString = optionString + 'data-max="' + max + '" ';

      optionString = optionString + ">";
      optionString = optionString + optionLabel;
      optionString = optionString + "</span>";
      if ((typeof min !== "undefined") & (typeof max !== "undefined")) {
        let quantityString = "<select class='wide'>";
        if (option.label == 'Adult') {
          if (max > min) {
            quantityString = quantityString + "<option selected>" + min + "</option>";
            bookButton.prop("disabled", false);
          }
        } else {
          if (max > min) {
            quantityString = quantityString + "<option selected>" + 0 + "</option><option>" + 0 + "</option>";
          }
        }

        for (let i = min; i <= max; i++) {
          quantityString = quantityString + "<option>" + i + "</option>";
        }

        quantityString = quantityString + "</select>";
        let optionRow = '<div class="' + option.label.toLowerCase() + '">' + optionString + quantityString + '</div>';
        publicParticipants.append(optionRow);
        publicParticipants.children('div').children('select').niceSelect();
        publicParticipants.children('div').children('select').niceSelect("update");

        if (max == min) {
          calculatePrice();
        }
      }
    });
    optionsSelect.niceSelect();
    optionsSelect.niceSelect("update");
  } else {
    options.addClass("show");
    optionsSelect.html("");
    optionsSelect.append(
      "<option disabled selected>" + optionsTitle + "</option>"
    );
    priceOptions.forEach(option => {
      let id = option.id;
      let min = 1;
      let max = 50;
      let optionString = '<option data-price="' + option.price + '"';

      optionString = optionString + 'data-id="' + id + '" ';

      if (typeof option.minQuantity !== "undefined") {
        min = option.minQuantity;
      }
      optionString = optionString + 'data-min="' + min + '" ';

      if (typeof option.maxQuantity !== "undefined") {
        max = option.maxQuantity;
      }
      optionString = optionString + 'data-max="' + max + '" ';

      optionString = optionString + ">";
      optionString = optionString + option.label;
      optionString = optionString + "</option>";
      optionsSelect.append(optionString);
    });
    optionsSelect.niceSelect();
    optionsSelect.niceSelect("update");
  }

});

function calculatePrice() {
  if (publicOrPrivate == 'public') {
    let priceAdult = parseInt($(".adult span").attr('data-price'));
    let countAdult = parseInt($('.adult select').val());
    let priceChild = parseInt($(".child span").attr('data-price'));
    let countChild = parseInt($('.child select').val());
    let priceInfant = parseInt($(".infant span").attr('data-price'));
    let countInfant = parseInt($('.infant select').val());
    let total;
    if (isNaN(priceChild) && isNaN(priceInfant)) {
      total = priceAdult * countAdult;
    } else if (isNaN(priceChild)) {
      total = priceAdult * countAdult + priceInfant * countInfant;
    } else if (isNaN(priceInfant)) {
      total = priceAdult * countAdult + priceChild * countChild;
    } else {
      total = priceAdult * countAdult + priceChild * countChild + priceInfant * countInfant;
    }
    let title = $("#totalPrice").attr("data-totalTitle");
    $("#priceValue").html(total);
    $("#priceTitle").html(title);
    bookButton.prop("disabled", false);
    bookButton.removeAttr("disabled");
  }
  else {

    let price = $('.filters-tour__options select option:selected').attr('data-price');
    let count = participantsSelect.val();

    let total = price * count;
    let title = $("#totalPrice").attr("data-totalTitle");

    $("#priceValue").html(total);
    $("#priceTitle").html(title);

    bookButton.prop("disabled", false);
    bookButton.removeAttr("disabled");
  }
}

function createGetQuery() {
  tourId = $('.filters-tour__variants select').val() == '' ? $('.filters-tour__variants select').val() : $('.filters-tour__btn').attr('data-post-id');

  let tourData = {
    tourdate: selectedTourDate,
    tourid: tourId,
    tourlanguage: language,
    publicorprivate: publicOrPrivate,
  };
  let tourDataToString = decodeURIComponent($.param(tourData))

  window.history.replaceState({}, document.title, "?" + tourDataToString);
}
function advertisingPrice() {
  let advPrice = $("#priceValue").attr("data-advPrice");
  let title = $("#totalPrice").attr("data-advertisingPriceTitle");

  $("#priceValue").html(advPrice);
  $("#priceTitle").html(title);

  bookButton.prop("disabled", true);
}

function initCalendar() {

  calendar.datepicker({
    altField: ".calendar__date",
    altFormat: "dd/mm/yy",
    dateFormat: "yy-mm-dd 00:00:00",
    firstDay: 1,
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    showOtherMonths: true,
    selectOtherMonths: true,
    prevText: "",
    nextText: "",
    onSelect: function () {
      let currentDate = $(this).val();
      calendar.attr('data-selecteddate', currentDate);
      selectedTourDate = calendar.attr('data-selecteddate');
      createGetQuery();
      getPriceOptions(currentDate);
    },
  });
  initCurrentDate();
}

function initCurrentDate() {
  let currentDate = calendar.val();

  getPriceOptions(currentDate);
}

function getPriceOptions(date) {
  advertisingPrice();
  preloader.addClass("show");
  departure.removeClass("show");
  options.removeClass("show");
  participants.removeClass("show");
  publicParticipants.removeClass("show");

  $.ajax({
    url: themeVars.ajax_url,
    type: "GET",
    data: {
      action: "tourAvialabilityPrices",
      productCode: calendar.attr("data-productcode"),
      baseCurrency: calendar.attr("data-basecurrency"),
      date: date,
    },
    success: function (data) {

      let datesArr = JSON.parse(data);
      currentDay = $('.ui-datepicker-current-day');
      if (datesArr.length > 0) {
        localStorage.prices = data;

        if (currentDay.hasClass('highlight-available') || currentDay.hasClass('highlight-limited')) {
          departure.addClass("show");
          departureSelect.html("");
          departureSelect.append(
            "<option disabled selected>" + departureTitle + "</option>"
          );
          datesArr.forEach(departure => {

            let formatedDate = moment(departure.startTimeLocal).format('YYYY-MM-DD HH:mm');
            let valueDate = moment(departure.startTimeLocal).format('YYYY-MM-DD HH:mm:ss')

            departureSelect.append(
              '<option value="' +
              valueDate +
              '">' + formatedDate +
              "</option>"
            );
          });
          departureSelect.niceSelect();
          departureSelect.niceSelect("update");
          $(".nice-select")
            .removeClass("open")
            .addClass("margin-default");
          $(".nice-select")
            .children(".current")
            .removeClass("opened");
          options.removeClass("show");
        } else {
          departure.removeClass("show");
        }
      }
      preloader.removeClass("show");
    },
  });
}

function highLight(date) {
  let marker;
  let day;
  let count;
  for (var i = 0; i < datesArr.length; i++) {
    day = datesArr[i][0];
    count = datesArr[i][1];
    if (count > 10) {
      marker = "highlight-available";
    } else {
      marker = "highlight-limited";
    }
    if (count == 0) {
      marker = "highlight-sold";
    }
    day = day.replace(/["]/g, "").replace(/[-]/g, "/");
    if (new Date(day).toString() == date.toString()) {
      return [true, marker, count.toString()];
    }
  }
  return [true, "highlight-notavailable", "Not available"];
}

function updateCalendar(code) {

  preloader.addClass("show");
  $('.filters-tour__title').hide();
  $('.preloader').addClass("show");

  $('.filters-tour__title').hide();
  $('.filters-tour__title.bookingtitle').hide();
  $('.filters-tour__title.waittitle').show();

  $.ajax({
    url: themeVars.ajax_url,
    type: "GET",
    data: {
      action: "tourAvialabilityDates",
      productCode: code,
    },
    success: function (data) {
      try {
        datesArr = JSON.parse(data);
        if (datesArr.length !== 0) {
          calendar.datepicker("option", { beforeShowDay: highLight });
          calendar.datepicker("refresh");
          preloader.removeClass("show");
          $('.preloader').removeClass("show");

          $('.filters-tour__title').show();
          $('.filters-tour__form').show();

          $('.filters-tour__title').show();
          $('.filters-tour__title.waittitle').hide();
          $('.filters-tour__title.bookingtitle').hide();

          $('.filters-tour_form-block').hide();
          $('.calendar-section').show();

        } else {

          $('.filters-tour__title').hide();
          $('.filters-tour__title.waittitle').hide();
          $('.filters-tour__title.bookingtitle').show();

          $('.filters-tour_form-block').show();
          $('.calendar-section').hide();

          $('.preloader').removeClass("show");

        }
      } catch (e) {
        preloader.removeClass("show");
        $('.preloader').removeClass("show");
        $('.filters-tour__title').show();

      }
    },
  });
}

function updateStoryAndLanguages(tourId, type) {
  $.ajax({
    url: themeVars.ajax_url,
    type: "GET",
    data: {
      action: "getStoryAndLanguages",
      tourId: tourId,
      type: type,
    },
    success: function (response) {
      try {
        $('.tour-main-block__story').html(response.data.story);
        $('.tour .entry-content').html(response.data.desc);
        $('.additionalInfo').html(response.data.additionalInfo);
        $('.cancellation-policy').html(response.data.cancelationPolicy);

        $('.filters-tour__lang').empty();
        $('.filters-tour__lang').html('<select class="wide"></select>');

        $.each(response.data.languages, function (key, val) {
          $('.filters-tour__lang select').append('<option value="' + key + '">' + val + '</option>');
        });

        $('.filters-tour__lang select').niceSelect();

      } catch (e) {
        preloader.removeClass("show");
      }
    },
  });
}

$(document).on('change', ".filters-tour__variants select", function () {
  $('.filters-tour__form').hide();
  $('.filters-tour__title').hide();

  $('.preloader').addClass("show");
  $("html, body").animate(
    { scrollTop: $(".single-tour-wrapper").offset().top - 20 },
    1000
  );
  let tourId = $(this)
    .children("option:selected")
    .val();
  language = $('.filters-tour__lang select').val();
  publicOrPrivate = $(".filters-tour__radio:checked").attr('data-value');
  let tourData = {
    tourdate: selectedTourDate,
    tourid: tourId,
    tourlanguage: language,
    publicorprivate: publicOrPrivate,
  };
  let tourDataToString = decodeURIComponent($.param(tourData))
  $.ajax({
    url: themeVars.ajax_url,
    type: "GET",
    data: {
      action: "singleTourLoad",
      tourId: tourId,
      tourDate: selectedTourDate,
      tourLanguage: language,
      publicOrPrivate: publicOrPrivate,
    },
    success: function (response) {
      window.history.replaceState({}, document.title, "?" + tourDataToString);
      $('.preloader').removeClass("show");

      $('.single-tour-wrapper').html(response.mainContent);
      $('.entry-content').html(response.postHeaderInfo);
      $('.entry-title').html(response.postTitle);
      $('.day-of-tour').html(response.postDayOfTour);
      $('.filters-tour__title').show();

      currentCode = $(".calendar").attr("data-productcode");
      currentDay = $('.ui-datepicker-current-day');
      calendar = $(".calendar");
      preloader = $(".calendar__preloader");
      departure = $(".filters-tour__departureSelect");
      departureSelect = $(".filters-tour__departureSelect select");
      options = $(".filters-tour__options");
      optionsSelect = $(".filters-tour__options select");
      participants = $(".filters-tour__participants");
      participantsSelect = $(".filters-tour__participants select");
      bookButton = $(".filters-tour__btn input");

      let item = [
        {
          'item_id': currentCode,
          'item_name': response.postTitle,
        },
      ];
      selectItemDataLayer(item);


      initCalendar();
      calendar.val(selectedTourDate);

      $(".sel > select").niceSelect();
      publicOrPrivateChecker();
      getPriceOptions(selectedTourDate);
      calendar.datepicker("setDate", selectedTourDate);

    },
  });
});


let cart = JSON.parse(localStorage.getItem("cart")) || [];

if (cart.length > 0) {
  cartIcon.addClass("counter-icon").text(cart.length);
  $(".header-icons__item_cart").addClass('filled')
}

$(document).on('click', ".filters-tour__btn input", function () {
  if (publicOrPrivate == 'public') {
    let groupValue = 1;
    let quantityAdult = $(".adult select option:selected").val();
    let quantityChild = $(".child select option:selected").val();
    let quantityInfant = $(".infant select option:selected").val();
    let optionsSelectValueAdult = 'Adult';
    if (quantityAdult === '') quantityAdult = 1;
    let tourPriceSingleAdult = parseInt($(".adult span").attr('data-price'));
    let tourPriceAdult = tourPriceSingleAdult * quantityAdult;
    let tourOptionIdAdult = $(".adult span").attr('data-id');

    addInCart(groupValue, quantityAdult, tourPriceAdult, tourPriceSingleAdult, tourOptionIdAdult, optionsSelectValueAdult);

    if (quantityChild >= 1) {
      let tourPriceSingleChild = parseInt($(".child span").attr('data-price'));
      let tourPriceChild = tourPriceSingleChild * quantityChild;
      let tourOptionIdChild = $(".child span").attr('data-id');
      let optionsSelectValueAdult = 'Child';
      addInCart(groupValue, quantityChild, tourPriceChild, tourPriceSingleChild, tourOptionIdChild, optionsSelectValueAdult);
    }
    if (quantityInfant >= 1) {
      let tourPriceSingleInfant = parseInt($(".infant span").attr('data-price'));
      let tourPriceInfant = tourPriceSingleInfant * quantityInfant;
      let tourOptionIdInfant = $(".infant span").attr('data-id');
      let optionsSelectValueInfant = 'Infant';

      addInCart(groupValue, quantityInfant, tourPriceInfant, tourPriceSingleInfant, tourOptionIdInfant, optionsSelectValueInfant);
    }
  } else {
    let quantity = $(".filters-tour__participants select option:selected").val();
    if (quantity === '') quantity = 1;
    let groupValue = quantity;
    let tourPrice = $("#priceValue").text();
    let tourPriceSingle = $("#priceValue").text();
    addInCart(groupValue, quantity, tourPrice, tourPriceSingle, optionsSelectId, optionsSelectValue);
  }
});

function addInCart(groupValue, quantity, tourPrice, tourPriceSingle, optionsSelectId, optionsSelectValue) {
  currentCode = $(".calendar").attr("data-productcode");
  postId = $(".filters-tour__btn").attr("data-post-id");
  languageSelectValue = $('.filters-tour__lang select').val()

  let tour = {
    tourId: postId,
    tourCode: currentCode,
    tourLanguage: languageSelectValue,
    tourDate: departureSelectValue,
    tourVariations: [
      {
        groupValue: groupValue,
        quantity: quantity,
        tourOptionId: optionsSelectId,
        tourPrice: tourPrice,
        tourPriceCurrency: calendar.attr('data-currentcurrency'),
        tourPriceSingle: tourPriceSingle,
        tourOptions: optionsSelectValue,
      },
    ],
  };
  successMessage = $(".filters-tour__success")
  successMessage.show();
  bookButton.prop("disabled", true);

  const IsInCart =
    cart.filter(
      cartItem =>
        cartItem.tourCode === tour.tourCode &&
        cartItem.tourDate === tour.tourDate
    ).length > 0;

  if (IsInCart) {

    cart.map(function (cartItem) {
      if (
        cartItem.tourCode === tour.tourCode &&
        cartItem.tourDate === tour.tourDate
      ) {
        let newOptionVariation = tour.tourVariations[0];
        let existFlag = false;
        cartItem.tourVariations.map(option => {
          if (option.tourOptionId === newOptionVariation.tourOptionId) {
            option.quantity = parseInt(option.quantity) + parseInt(quantity);
            option.tourPrice =
              parseInt(option.tourPrice) +
              parseInt(newOptionVariation.tourPrice);
            existFlag = true;
          }
          return option;
        });

        if (!existFlag) {
          cartItem.tourVariations.push(newOptionVariation);
        }
      }
      return cartItem;
    });
    localStorage.setItem("cart", JSON.stringify(cart));
  } else {
    cart.push(tour);
    localStorage.setItem("cart", JSON.stringify(cart));
  }
  if (cart.length == 1) {
    cartIcon.addClass("counter-icon").html(cart.length);
    $(".header-icons__item_cart").addClass('filled');
  } else {
    cartIcon.html(cart.length);
  }

  let item = [
    {
      'item_id': currentCode,
      'item_name': $('.entry-title').text(),
      'price': tourPriceSingle,
      'item_variant': optionsSelectValue,
      'quantity': quantity,
    },
  ];

  addToCartDataLayer(tourPrice, item);
}

document.addEventListener( 'wpcf7submit', function( event ) {
  if (event.detail.contactFormId == 27068 || event.detail.contactFormId == 47090 || event.detail.contactFormId == 47091) {
    let value = $('.filters-tour_form-block').attr('data-advertisingPrice');
    let unique_id = $('.filters-tour_form-block input[type="email"]').val() + Date.now();
    generateLeadDataLayer(value, unique_id);
  }
}, false );




// WEBPACK FOOTER //
// ./scripts/modules/single-tour.js